import { useQuery } from '@tanstack/react-query';
import { fetchTripList } from '@/api/trips';
import { tripListKeys } from '@/api/queryKeys';

export function useTripList() {
  return useQuery({
    queryKey: tripListKeys.all(),
    queryFn: ({ signal }) => fetchTripList(signal).then((r) => r.trips),
    staleTime: 60_000,
  });
}
